import { inject, Injector, Signal, TemplateRef } from '@angular/core';
import { Dismissed, ResolvableModalConfig } from '../types/modal-config';
import { ModalService } from '../modal.service';
import { SignatureModalComponent } from '../components/signature-modal/signature-modal.component';

export interface SignatureModalConfig2 {
  title?: string | Signal<string | null>;
  subtitle?: string | Signal<string | null>;
  text?: string | Signal<string | null>;
  content?: TemplateRef<any> | Signal<TemplateRef<any> | null>;
  contentContext?: object | Signal<object | null>;
  class?: string;
  dismiss?: boolean;
}

async function sign(modalService: ModalService, config: SignatureModalConfig2, injector: Injector): Promise<Blob | null | Dismissed> {
  const modalConfig: ResolvableModalConfig<SignatureModalComponent, Blob | null> = {
    component: SignatureModalComponent,
    dismiss: config.dismiss,
    title: config.title ?? 'Unterschreiben',
    subtitle: config.subtitle,
    text: config.text,
    template: config.content,
    templateContext: config.contentContext,
    priority: Number.POSITIVE_INFINITY,
    class: config.class,
    injector: injector
  }
  return await modalService.open(modalConfig);
}

export function signFn(): (config: SignatureModalConfig2) => Promise<Blob | null | Dismissed> {
  const modalService = inject(ModalService);
  const injector = inject(Injector);
  return (config) => sign(modalService, config, injector)
}
